export function SetupGuide(){
    return <div style={{height:"100%"}}>
        <iframe src="/GetRank%20Account%20Set%20Up.pdf" width="100%" style={{height:"calc( 100vh - 100px )"}} />
    </div>
}